import React, { useEffect, useState } from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import { Button } from 'react-dxd-components'
import { useNavigate } from 'react-router-dom'
import useScrollToTop from '../../hooks/useScrollToTop'

export default function BenAdminIntegrationTesting () {
  const [value, setValue] = useState()
  const navigate = useNavigate()

  useEffect(() => {
    if (window.location.href.includes('eoi-online.mutualofomaha.com')) {
      navigate('/home')
    }
  }, [navigate])

  return useScrollToTop(<Grid container className='container-md' centered>
    <GridRow>
      <GridColumn width={12}>
        <h5>Ben Admin Integration Testing (internal)</h5>
        <h5>Add a saml token and submit to test</h5>
      </GridColumn>
    </GridRow>
    <GridRow>
      <GridColumn width={12}>
        <form method='post' action='/api/ben-admin/testing' target='_blank'>
        <textarea
          name='samlToken'
          className='Textarea'
          id='eoiPayload'
          data-testid='eoiPayload'
          rows={15}
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
          <GridColumn className='u-mY2' width={12} verticalAlign='bottom' textAlign='right'>
            <Button type='submit'>Submit</Button>
          </GridColumn>
        </form>
      </GridColumn>
    </GridRow>
  </Grid>)
}